import { BaseSerializer } from "../../../shared/models/serializers/baseSerializer.ts";
import { Tags } from "../../../shared/models/tags.model.ts";

export class TagSerializer extends BaseSerializer{

  public deserialize( data: any ): any {
    const gp = new Tags();
    this._copyAttributes(gp, data);
    return gp;

}
}
